import { tv } from 'tailwind-variants';

export default tv({
  base: `
   absolute
   left-[30px]
   top-[30px]
   h-auto
   w-[calc(100%-60px)]
  `,
});
